import { render, staticRenderFns } from "./promoDeals.pug?vue&type=template&id=0625b3ff&scoped=true&lang=pug&"
import script from "./promoDeals.ts?vue&type=script&lang=ts&"
export * from "./promoDeals.ts?vue&type=script&lang=ts&"
import style0 from "./promoDeals.scss?vue&type=style&index=0&id=0625b3ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0625b3ff",
  null
  
)

export default component.exports